"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObserverContext = void 0;
const react_1 = require("react");
exports.ObserverContext = (0, react_1.createContext)(undefined);
